import FormGenerator from 'Presentation/Components/Form/FormGenerator'

const BillPlanButton: React.FC<{
	active?: boolean
	onChange?: (plan: string) => void
	disabled?: boolean
	value: string
	title: string
	price: string
	description: string
}> = ({ disabled, active, onChange, value, title, price, description }) => {
	const activeClass = 'border border-kumopack-primary-600 bg-kumopack-primary-50 rounded p-2'
	const inActiveClass = 'border border-kumopack-grey-200 bg-kumopack-base-white rounded p-2'

	const activeTitleClass = 'text-kumopack-primary-800 fw-bold'
	const inActiveTitleClass = 'text-kumopack-grey-700 fw-bold'

	const activeSubTextClass = 'text-kumopack-primary-700'
	const inActiveSubTextClass = 'text-kumopack-grey-600'

	return (
		<div
			className={`${active ? activeClass : inActiveClass} row py-5 cursor-pointer transition-300`}
			onClick={() => (onChange ? onChange(value) : {})}
			style={{ flexWrap: 'nowrap' }}>
			<div className="col-10">
				<span className={`fs-5 ${active ? activeTitleClass : inActiveTitleClass}`}>{title}</span>
				<span className={`ms-1 ${active ? activeSubTextClass : inActiveSubTextClass}`}>
					{price}
				</span>
				<p className={`${active ? activeSubTextClass : inActiveSubTextClass} mb-0`}>
					{description}
				</p>
			</div>
			<div className="col-2 justify-content-end d-flex align-items-center">
				<FormGenerator
					formKey="bill-plan-radio-button"
					inputType="radio"
					value={active}
					onChange={e => {
						if (e.currentTarget.value === 'on' && onChange) {
							onChange(value)
						}
					}}
					disabled={disabled}
				/>
			</div>
		</div>
	)
}

export default BillPlanButton
